@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {
  display: block;

  .jui-radio {
    align-items: center;

    &--flex {
      display: flex;
    }

    &__input {
      margin-top: 0;
      &--mobile {
        display: none;

        //&:checked + .jui-radio__label {
        //  border: 1px solid red;
        //}
      }
      &--md {
        transform: scale(1.25);
      }

      &--lg {
        transform: scale(1.5);
      }
    }
    &__label {
      margin-left: var(--jds-space-xs);

      &--sm {
        font-size: var(--jui-input-fs-sm);

      }

      &--md {
        font-size: var(--jui-input-fs);
      }

      &--lg {
        font-size: var(--jui-input-fs-lg);
        margin-left: var(--jds-space-sm);
      }

      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }

    }
  }
}
